import {Injectable} from '@angular/core';
import {BandwidthService} from './bandwidth.service';

@Injectable({
    providedIn: 'root'
})
export class AutoResolutionService {
    private readonly resolutionToBandwidthMap: Map<string, number> = new Map([
        ['1080p', 6144],
        ['720p', 3584],
        ['540p', 2048],
        ['360p', 0]
    ]);

    constructor(private bandwidthService: BandwidthService) {
    }

    getBestResolution(availableResolutions: string[]): string {
        const currentBandwidth = this.bandwidthService.kbps;

        if (currentBandwidth === -1) {
            return '720p'
        }

        for (const [resolution, bandwidth] of this.resolutionToBandwidthMap.entries()) {
            if (availableResolutions.includes(resolution) && currentBandwidth >= bandwidth) {
                return resolution;
            }
        }

        // fallback to lowest resolution
        return availableResolutions[availableResolutions.length - 1];
    }
}
